import React from 'react';
import PropTypes from 'prop-types';

import BaseListItem from '../BaseListItem';
import getFavoriteHook from '@hooks/getFavoriteHook';

const ArticleListItem = props => {
    const {
        id,
        title,
        url,
        photoURL,
        taxonomyArticlesType = [],
        displayDate,
        isFavorite: initialIsFavorite,
        hidePhoto,
        onClick = () => {},
        isLoggedIn = false,
    } = props;
    const useFavorite = getFavoriteHook({ type: 'article', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = () => {
        if (!isFavorite) {
            saveFavorite(id);
        } else {
            removeFavorite(id);
        }
    };

    const imageBlock = hidePhoto ? null : (
        <>
            {photoURL && <img src={photoURL} alt={title} className="px-0 py-2 card-img-right" />}
            {!photoURL && (
                <img
                    src="/assets/images/generic-icon-article.svg"
                    alt=""
                    className="px-2 pt-2 card-img-right download bg-gray-lightest"
                />
            )}
        </>
    );

    return (
        <BaseListItem
            id={id}
            type="article"
            title={title}
            url={url}
            isLoadingFavorite={isLoadingFavorite}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            imageBlock={imageBlock}
            isLoggedIn={isLoggedIn}
            contentBlock={
                <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                    <h3
                        className="card-title mt-1 mb-0 ml-0 mx-0 py-0 display8 bold d7-truncate2 truncate-lines"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <p className="display9 secondary mt-1 mb-0">
                        {!taxonomyArticlesType || (taxonomyArticlesType.length === 0 && 'Article')}
                        {taxonomyArticlesType && taxonomyArticlesType.join(', ')}
                        {displayDate && `- ${displayDate}`}
                    </p>
                </a>
            }
        />
    );
};

ArticleListItem.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    photoURL: PropTypes.string,
    taxonomyArticlesType: PropTypes.array,
    displayDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    isFavorite: PropTypes.bool,
    hidePhoto: PropTypes.bool,
    onClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
};

export default ArticleListItem;
